var render = function render(){var _vm=this,_c=_vm._self._c;return _c('system-activity-base',{attrs:{"uri":_vm.uri,"campaigns-id":_vm.campaignsId,"campaigns-filter":_vm.campaignsFilter,"date-range":_vm.dateRange,"config-file":_vm.config,"tab":_vm.tab,"timezone":_vm.timezone,"showUTCtime":_vm.showUTCtime}})
}
var staticRenderFns = []

export { render, staticRenderFns }